import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import './index.less'
import PageLayout from '../../Components/pageLayout'
import { Carousel, Image, Flex } from 'antd';

import banner1 from '../../static/banner1.png'
import banner2 from '../../static/banner2.png'
import banner3 from '../../static/banner3.png'
import home1 from '../../static/home1.webp'

import person1 from '../../static/person1.webp'
import person2 from '../../static/person2.webp'
import person3 from '../../static/person3.webp'

import chunfeng1 from '../../static/chunfeng1.webp'
import chinahappy1 from '../../static/chinahappy1.webp'
import hairai1 from '../../static/hairai1.webp'


import data31 from '../../data/data31.json'
import data32 from '../../data/data32.json'
import data41 from '../../data/data41.json'
import data61 from '../../data/data61.json'

type PageOwnProps = {
    history: any,
}

type PageState = {
    activeTab: string,
}

class Home extends React.Component<PageOwnProps, PageState> {
    constructor(props: any) {
        super(props)
        this.state = {
            activeTab: 'institutional'
        }
    }

    componentDidMount() {

    }

    switchTab = (tab: string) => {
        this.setState({ activeTab: tab });
    }

    navigateToArticle = (dataId: string, articleId: string) => {
        this.props.history.push(`/article/${dataId}/${articleId}`);
    };


    render() {
        const { activeTab } = this.state;

        return (
            <PageLayout history={this.props.history} Content={<div className='home'>
                <Carousel arrows infinite autoplay={true} draggable>
                    <div>
                        <Image preview={false} className='banner' src={banner1} />
                    </div>
                    <div>
                        <Image preview={false} className='banner' src={banner2} />
                    </div>
                    <div>
                        <Image preview={false} className='banner' src={banner3} />
                    </div>
                </Carousel>

                <div className="content-container">
                    {/* 关于我们 */}
                    <div className="about-container">
                        <h2 className="section-title">关于我们</h2>
                        <div className="about-content">
                            <div className="about-image">
                                <Image preview={false} src={home1} alt="关于我们" />
                            </div>
                            <div className="about-text">
                                <p>绿城爱心基金会以“心理关爱、造福社会、创造价值、彰显品牌”为宗旨，以造福社会、创造价值为使命，以“理想生活、健康人生”为愿景，
                                    立足于心理健康方面的公益慈善事业。</p>
                                <a href="/foundation-intro" className="about-link">了解更多</a>
                            </div>
                        </div>
                    </div>

                    {/* 新闻资讯 */}
                    <div className="news-container">
                        <h2 className="section-title">新闻资讯</h2>
                        <div className="news-tabs">
                            <div
                                className={`tab ${activeTab === 'institutional' ? 'active' : ''}`}
                                onClick={() => this.switchTab('institutional')}
                            >
                                机构新闻
                            </div>
                            <div
                                className={`tab ${activeTab === 'industry' ? 'active' : ''}`}
                                onClick={() => this.switchTab('industry')}
                            >
                                行业动态
                            </div>
                        </div>
                        <div className="news-list">
                            {activeTab === 'institutional' && data31.slice(0, 5).map((item: any, index: number) => (
                                <div key={index} className="news-item" onClick={() => this.navigateToArticle('31', item.id)}>
                                    <h3 className="news-item-title">{item.title}</h3>
                                </div>
                            ))}
                            {activeTab === 'industry' && data32.slice(0, 5).map((item: any, index: number) => (
                                <div key={index} className="news-item" onClick={() => this.navigateToArticle('32', item.id)}>
                                    <h3 className="news-item-title">{item.title}</h3>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* 党建专栏 */}
                    <div className="party-container">
                        <h2 className="section-title">党建专栏</h2>
                        <div className="party-content">
                            <div className="party-members">
                                <div className="member-card">
                                    <Image preview={false} src={person1} />
                                    <div className="member-name">刘   虹</div>
                                    <div className="member-name">中共绿城公益联合临时支部委员会 书记</div>
                                </div>
                                {/* <div className="member-card">
                                    <Image preview={false} src={person2} />
                                    <div className="member-name">蒋  讯  雯</div>
                                </div>
                                <div className="member-card">
                                    <Image preview={false} src={person3} />
                                    <div className="member-name">周  红  素</div>
                                </div> */}
                            </div>
                            <div className="party-news">
                                <h3 className="section-title">党建活动</h3>
                                {data41.slice(0, 5).map((item: any, index: number) => (
                                    <div key={index} className="news-item" onClick={() => this.navigateToArticle('41', item.id)}>
                                        <div className="news-item-title">{item.title}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* 公益项目 */}
                    <div className="project-container">
                        <h2 className="section-title">公益项目</h2>
                        <div className="project-list">
                            <div className="project-card">
                                <div className="project-image">
                                    <Image preview={false} src={chunfeng1} />
                                </div>
                                <div className="project-info">
                                    <div className="project-name">春风行动</div>
                                    <a href="/spring-action" className="project-link">查看详情</a>
                                </div>
                            </div>
                            <div className="project-card">
                                <div className="project-image">
                                    <Image preview={false} src={chinahappy1} />
                                </div>
                                <div className="project-info">
                                    <div className="project-name">无郁中国行</div>
                                    <a href="/happy-china" className="project-link">查看详情</a>
                                </div>
                            </div>
                            <div className="project-card">
                                <div className="project-image">
                                    <Image preview={false} src={hairai1} />
                                </div>
                                <div className="project-info">
                                    <div className="project-name">爱咪听见</div>
                                    <a href="/hear-love" className="project-link">查看详情</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 规章制度 */}
                    <div className="disclosure-container">
                        <h2 className="section-title">规章制度</h2>
                        <div className="regulation-list">
                            {data61.slice(0, 5).map((item: any, index: number) => (
                                <div key={index} className="regulation-item" onClick={() => this.navigateToArticle('61', item.id)}>
                                    <div className="regulation-item-title">{item.title}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>}>
            </PageLayout>
        )
    }
}

export default Home;